import { createSelector } from '@reduxjs/toolkit';
import { usesEmbeddedUrl } from 'features/payments/utils/conekta-presentation.util';
import { createEmbeddedConektaUrl } from 'features/payments/utils/create-embedded-conekta-url.util';

export const conektaPaymentActionSelector = state =>
  state.wnPayments.conektaPaymentAction;

export const conektaPaymentOrderIdSelector = createSelector(
  [conektaPaymentActionSelector],
  paymentAction => paymentAction?.orderId ?? null,
);

// Fuera del iframe se usa la URL tal cual (integración por redirección). El sufijo
// `source=embbeded` NO sirve ahí: hace que Conekta avise con
// `window.parent.postMessage`, que solo llega a esta app cuando el reto corre
// dentro de un iframe.
export const conektaPaymentURLSelector = createSelector(
  [conektaPaymentActionSelector],
  paymentAction => {
    if (!paymentAction) return null;
    return usesEmbeddedUrl()
      ? createEmbeddedConektaUrl(paymentAction.redirectUrl)
      : paymentAction.redirectUrl;
  },
);
